// Styles
import './styles/base.css';
import './styles/layout.css';
import './styles/home-tabs.css';
import './styles/topbar.css';
import './styles/stage.css';
import './styles/modal.css';
import './styles/dropdown.css';
import './styles/conflict.css';
import './styles/preview.css';
import './styles/editor.css';
import './styles/convert.css';
import './styles/preload.css';
import './styles/responsive.css';

// Modules with side-effects (DOM listeners) — load order matters for DOM-querying
// initializers. Modules without imports come first; dependents follow.
import './js/theme.js';
import './js/session.js';
import { initLibrary } from './js/library.js';
import './js/ui/modal.js';
import './js/ui/dropdown.js';
import './js/editor.js';
import './js/preview.js';
import './js/upload.js';
import './js/select.js';
import './js/home.js';
import './js/convert.js';
import './js/verify.js';
import './js/download.js';
import './js/preload.js';
import './js/manage.js';

// ===== Mobile layout detection =====
// CSS alone can't reliably tell a real phone from a zoomed desktop, and some
// phone browsers / in-app webviews misreport pointer/hover (e.g. `pointer: fine`
// on an actual touchscreen) — which left the strict `(hover:none) and
// (pointer:coarse)` query unmatched, dropping the phone into the desktop 3-column
// layout where the middle preview is crushed to nothing and only the editor shows.
// Decide in JS instead: a touch-capable device on a narrow viewport gets the
// single-column, preview-only mobile layout (body.is-mobile). A non-touch desktop
// never qualifies, so zooming never collapses the 3-column layout; a touch laptop
// stays desktop because its viewport is wide.
const MOBILE_MAX_WIDTH = 1024;
function isTouchDevice() {
  return (window.matchMedia &&
      (matchMedia('(pointer: coarse)').matches || matchMedia('(any-pointer: coarse)').matches))
    || navigator.maxTouchPoints > 0
    || 'ontouchstart' in window;
}
function syncMobileLayout() {
  const mobile = isTouchDevice() && window.innerWidth <= MOBILE_MAX_WIDTH;
  document.body.classList.toggle('is-mobile', mobile);
}
syncMobileLayout();
window.addEventListener('resize', syncMobileLayout);
window.addEventListener('orientationchange', syncMobileLayout);

// Reveal immediately for fast first paint — the home screen doesn't depend on
// the library. Hydrate IndexedDB in the background; browse/download/convert lists
// read it when opened (after hydration has long since completed).
document.documentElement.classList.add('ready');
initLibrary();
